import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThTotalWithVatConfigurationComponent } from "./th-total-with-vat-configuration.component";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { VatConfigurationModule } from "libraries/component/vat-configuration-form/vat-configuration.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { ReactiveFormsModule } from "@angular/forms";
import { MatMenuModule } from "@angular/material/menu";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
    declarations: [ThTotalWithVatConfigurationComponent],
    exports: [ThTotalWithVatConfigurationComponent],
    imports: [
        CommonModule,
        ThTextModule,
        MatMenuModule,
        VatConfigurationModule,
        BtnModule,
        ReactiveFormsModule,
        MatDialogModule,
    ]
})
export class ThTotalWithVatConfigurationModule {
}
